import api from './api';

export interface Schedule {
  id: string;
  workflowId: string;
  cron: string;
  inputData: Record<string, unknown> | null;
  enabled: boolean;
  nextRunAt: string | null;
  lastRunAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateScheduleInput {
  workflowId: string;
  cron: string;
  inputData?: Record<string, unknown>;
  enabled?: boolean;
}

export const schedulesService = {
  async list(): Promise<Schedule[]> {
    const response = await api.get<Schedule[]>('/schedules');
    return response.data;
  },
  async create(data: CreateScheduleInput): Promise<Schedule> {
    const response = await api.post<Schedule>('/schedules', data);
    return response.data;
  },
  async update(
    id: string,
    data: { cron?: string; inputData?: Record<string, unknown>; enabled?: boolean }
  ): Promise<Schedule> {
    const response = await api.patch<Schedule>(`/schedules/${id}`, data);
    return response.data;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/schedules/${id}`);
  },
};
